import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';

import { selectIsPMP } from 'lib/util/privateMarketplace';
import { DateFormPanel } from 'components/DateFormPanel/DateFormPanel';
import ProductContentsView from '../ProductContentsView/ProductContentsView';
import { ProductDetailsViewProps } from 'lib/themes/themes';
import config from 'config';

const ProductDetailsView = ({
  product,
  productListPath,
  productListEnabled,
  shouldShowBookNowButton,
  features,
}: ProductDetailsViewProps) => {
  const { t } = useTranslation();
  const [calendarRef, calendarInView] = useInView();

  const router = useRouter();

  const isPMP = useSelector(selectIsPMP);

  const shouldShowPricingOnCalendar =
    config.enableShowPricingOnBwCalendar &&
    (product?.should_show_pricing_on_bw_calendar?.value ?? false);

  return (
    <>
      <div className={clsx('base-subHeader', shouldShowPricingOnCalendar && 'price')}>
        <div className="base-single">
          <div className="base-subHeader__inner">
            {productListEnabled ? (
              isPMP ? (
                <a className="base-subHeader__back" onClick={() => router.back()}>
                  <p className="base-subHeader__back__ic maincolor-bg">
                    <img src="/static/images/ic_arrow_back.svg" alt="back arrow" />
                  </p>
                </a>
              ) : (
                <Link href={productListPath} className="base-subHeader__back">
                  <p className="base-subHeader__back__ic maincolor-bg">
                    <img src="/static/images/ic_arrow_back.svg" alt="back arrow" />
                  </p>
                  <span className="maincolor-txt">{t('All Products')}</span>
                </Link>
              )
            ) : (
              <div className="base-subHeader__back" />
            )}
            {features.length > 0 && (
              <p className="base-subHeader__feature maincolor-border maincolor-txt">
                {features[0]}
              </p>
            )}
          </div>
        </div>
      </div>
      <article className={clsx('base-single', shouldShowPricingOnCalendar && 'price')}>
        <ProductContentsView product={product} />
        <div
          className={clsx({
            'base-single__fixed': true,
            'is-active': shouldShowBookNowButton && !calendarInView,
          })}
        >
          <a className="base-single__fixed__btn" href="#booking-calendar">
            {t('Book')}
          </a>
        </div>
        <div
          ref={calendarRef}
          id="booking-calendar"
          className={clsx('base-single__side', 'scroll-target-section')}
        >
          <div className="base-single__side__sticky">
            <DateFormPanel isEmbedded={false} showPrices={true} />
          </div>
        </div>
      </article>
    </>
  );
};

export default ProductDetailsView;
